import { RootState } from '@app/redux/root-reducer';

export const selectTestimonialState = (store: RootState) => store.testimonialReducer.testimonial;
export const selectDeleteTestimonialState = (store: RootState) =>
  store.testimonialReducer.deleteTestimonial;
export const selectAddTestimonialState = (store: RootState) =>
  store.testimonialReducer.addTestimonial;
export const selectUpdateTestimonialState = (store: RootState) =>
  store.testimonialReducer.updateTestimonial;
